import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Card } from "reactstrap";
import { useDispatch, useSelector } from 'react-redux';
import { getDoctor } from 'Services/Features/Doctor/Utils/doctorUtils';
import CustomLoader from 'Component/Common/CustomLoader';
import FindDoctor from './Filter/FindDoctor';
import DoctorContent from './DoctorContent';
import {
    handleNextPagination,
    handleBackPagination,
    handleClickPagination
} from 'Component/DashboardQeza/Common/PaginationUtils';
import PaginationComponent from 'Component/Common/PaginationComponent';
import { setFilters } from 'Services/Features/Doctor/doctorSlice';

const DoctorContain = () => {
    const dispatch = useDispatch();
    const doctors = useSelector((state) => state.doctor.doctors);
    const loading = useSelector((state) => state.doctor.loading);
    const error = useSelector((state) => state.doctor.error);
    const [refetch, setRefetch] = useState(false);
    const pagination = useSelector((state) => state.doctor.pagination);
    const filters = useSelector(state => state.doctor.filters);

    useEffect(() => {
        dispatch(getDoctor(filters));
        window.scrollTo(0, 0);
    }, [dispatch, refetch]);

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <Fragment>
            <Col md="12" className="project-list">
                <Card className="px-3">
                    <FindDoctor />
                </Card>
            </Col>
            <Col xl="12" className="xl-80">
                <Row>
                    {loading ? (
                        <CustomLoader />
                    ) : loading === false && doctors.length === 0 ? (
                        <Col md="12">
                            <div className="no-data-found d-flex flex-column align-items-center justify-content-center" style={{ height: '300px' }}>
                                <i className="fa fa-search" style={{ fontSize: '100px', color: '#ccc', marginBottom: '20px' }}></i>
                                <h5 style={{ fontSize: '24px' }}>Kategori Tidak Ditemukan</h5>
                            </div>
                        </Col>
                    ) : (
                        <Col sm="12">
                            <DoctorContent setRefetch={setRefetch} />
                        </Col>
                    )}
                </Row>
                <div style={{ marginTop: '150px' }}>
                    {loading === false && doctors && doctors.length > 0 && (
                        <PaginationComponent
                            pagination={pagination}
                            handleBackPagination={() => handleBackPagination(pagination, filters, dispatch, setFilters, setRefetch)}
                            handleClickPagination={(page) => handleClickPagination(page, filters, dispatch, setFilters, setRefetch)}
                            handleNextPagination={() => handleNextPagination(pagination, filters, dispatch, setFilters, setRefetch)}
                        />
                    )}
                </div>
            </Col>
        </Fragment>
    );
};

export default DoctorContain;